export default "__VITE_ASSET__CMB9I07i__"